const env = {
    production: false,
    api: {
        host: 'https://api-retcercano.ripley.com.pe/auth',
        x_api_key: '9mkMTwuiRq5r40EX2mhvk1kIRJrkwUMr4OLw2GUI',
    },
    recaptcha: {
        webKey: "6Ld0rjEaAAAAAJA0H81TzTlJjRL8JrOTxPeTs2ZN"
    }
  }
  
  export default env;